/* eslint-disable @typescript-eslint/no-unused-vars */
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Tabs, Theme, useTheme } from 'bold-ui'
import { PecSwitch, PrivateRoute, TabLink } from 'components/route'
import { addDays, parseISO } from 'date-fns'
import { useAcompanhamentoPreNatalQuery } from 'graphql/hooks.generated'
import { AtendimentoProfissional, ResultadoExame } from 'graphql/types.generated'
import { Fragment } from 'react'
import { Redirect, useLocation, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'
import { isBetween } from 'util/date/compare'
import { grupoCboVisualizarAcompanhamentos } from 'view/cidadao/acessos'

import { getDumAtual } from '../../soap/aside/pre-natal/util/util-acompanhamentoPreNatal'
import { QUANTIDADE_DIAS_FIM_PRIMEIRO_TRIMESTRE_GESTACAO } from '../../soap/pre-natal/model-preNatal'
import { InformacoesGestacaoTabContent } from './components/InformacoesGestacaoTabContent'
import { MedicoesGestacaoTabContent } from './components/MedicoesGestacaoTabContent'

const INFO_GESTACAO_URL = 'informacoes'
const MEDICOES_GESTACAO_URL = 'medicoes'

interface AcompanhamentoPreNatalTabsProps {
  cidadaoId: ID
  prontuarioId: ID
  dataReferencia: Instant
}

export const AcompanhamentoPreNatalTabs = (props: AcompanhamentoPreNatalTabsProps) => {
  const { cidadaoId, prontuarioId, dataReferencia } = props
  const match = useRouteMatch()
  const location = useLocation()
  const theme = useTheme()
  const styles = createStyles(theme)

  const baseUrlToRedirect = `${match.url}/${INFO_GESTACAO_URL}${location.search}`

  const {
    data: { atendimentosProfUltimaGestacao },
    loading: loadingAtendimentos,
  } = useAcompanhamentoPreNatalQuery({
    variables: {
      input: prontuarioId,
    },
    skip: !prontuarioId,
    fetchPolicy: 'cache-first',
  })

  const atendimentosProfissionaisUltimaGestacao = atendimentosProfUltimaGestacao as AtendimentoProfissional[]
  const dum = getDumAtual(atendimentosProfissionaisUltimaGestacao)

  // const {
  //   data: { resultadosExame },
  //   loading: loadingExames,
  // } = useResultadosExamePreNatalQuery({
  //   variables: {
  //     input: {
  //       prontuarioId,
  //     },
  //   },
  //   skip: !prontuarioId,
  //   fetchPolicy: 'cache-first',
  // })

  // const resultadosExamesAnteriores = (resultadosExame?.content as ResultadoExame[])?.filter((exame) =>
  //   isBetween(parseISO(exame.dataRealizacao), dum, addDays(dum, QUANTIDADE_DIAS_FIM_PRIMEIRO_TRIMESTRE_GESTACAO))
  // )

  // const [listaEcoOrdenadaDesc] = getListaEcoOrdenadaDesc(resultadosExamesAnteriores, dum)

  // const {
  //   dataProvavelParto: dppEcografica,
  //   dataInicioGestacao,
  //   isDataInicioGestacaoEcografica,
  // } = getInicioGestacaoEDataProvavelParto(dum, listaEcoOrdenadaDesc)

  // const renderInformacoesGestacao = () => (
  //   <InformacoesGestacaoTabContent
  //     cidadaoId={cidadaoId}
  //     prontuarioId={prontuarioId}
  //     dataReferencia={dataReferencia}
  //     loading={loadingAtendimentos || loadingExames}
  //     dum={dum}
  //     dataInicioGestacao={dataInicioGestacao}
  //     dppEcografica={dppEcografica}
  //     quantidadeConsultas={atendimentosProfissionaisUltimaGestacao?.length}
  //     dataUltimaConsulta={atendimentosProfissionaisUltimaGestacao?.last()?.iniciadoEm}
  //   />
  // )

  // const renderMedicoes = () => (
  //   <MedicoesGestacaoTabContent
  //     prontuarioId={prontuarioId}
  //     dataInicioGestacao={dataInicioGestacao}
  //     atendimentosProfUltimaGestacao={atendimentosProfUltimaGestacao as AtendimentoProfissional[]}
  //     isDataInicioGestacaoEcografica={isDataInicioGestacaoEcografica}
  //     loading={loadingAtendimentos || loadingExames}
  //   />
  // )

  return (
    <Fragment>
      <div css={styles.container}>
        <Tabs style={styles.tabs}>
          <TabLink to={baseUrlToRedirect}>Informações da gestação</TabLink>
          <TabLink to={`${match.url}/${MEDICOES_GESTACAO_URL}${location.search}`}>Medições</TabLink>
        </Tabs>
      </div>
      <PecSwitch>
        <Redirect exact from={match.url} to={baseUrlToRedirect} />
        <PrivateRoute
          path={`${match.url}/${INFO_GESTACAO_URL}`}
          // render={renderInformacoesGestacao}
          permission={Permissions.visualizarProntuario}
          cbos={grupoCboVisualizarAcompanhamentos}
        />
        <PrivateRoute
          path={`${match.url}/${MEDICOES_GESTACAO_URL}`}
          // render={renderMedicoes}
          permission={Permissions.visualizarProntuario}
          cbos={grupoCboVisualizarAcompanhamentos}
        />
      </PecSwitch>
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    border-bottom: 1px solid ${theme.pallete.divider};
  `,
  tabs: css`
    border-bottom-width: 0;
    margin-bottom: 1rem;
  `,
})
